<template>
  <v-container class="grey lighten-5" fluid>
    <v-row justify="center">
      <h2>
        <span v-on:click="controlMonth('prev')" style="cursor: pointer">◀</span>
        {{year}}년 {{month}}월
        <span v-on:click="controlMonth('next')" style="cursor: pointer">▶</span>
      </h2>
    </v-row>
    <v-row no-gutters style="margin-bottom: 5px;">
      <v-col v-for="(weekName, index) in weekNames" :key="weekName" style="text-align: center;" v-if="index > 0 && index < 6">
        {{ weekName }}
      </v-col>
<!--      <v-col v-for="(weekName, index) in weekNames" v-bind:key="index" style="text-align: center" v-if="index < 5">
        {{weekName}}
      </v-col>-->
    </v-row>
    <v-row v-for="(date, index) in dates" :key="index" no-gutters>
      <v-col v-for="(value, index2) in date" :key="index2" v-if="index2 > 0 && index2 < 6" cols="12" class="col-lg5-custom">
        <v-sheet
            class="pa-2"
            tile
        >
          <v-card>
            <v-card-title style="padding-bottom: 5px;">{{value.day}}</v-card-title>
            <v-card-text>
              <v-row
                  justify="space-between"
                  class="mx-0"
              >
                <div class="red--text">
                  <div v-for="(rank, index) in getHighRankOfDay(value.date)" :key="index">
                    {{rank.theme}}
                  </div>
                </div>
                <div class="blue--text" style="text-align: right">
                  <div v-for="(rank, index) in getLowRankOfDay(value.date)" :key="index">
                    {{rank.theme}}
                  </div>
                </div>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-expansion-panels tile flat v-if="getScheduleOfDay(value.date) != null">
              <v-expansion-panel>
<!--                <v-expansion-panel-header style="font-size: 14px">{{getScheduleOfDay(value.date).title}}</v-expansion-panel-header>-->
                <v-expansion-panel-header style="font-size: 14px">주요 증시 일정</v-expansion-panel-header>
                <v-expansion-panel-content style="white-space: pre-line; font-size: 14px;">
                  <div v-html="getScheduleOfDay(value.date).contents">
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment";

export default {
  name: 'Calendar',
  props: ['calendar', 'dailyRanks'],
  data () {
    return {
      weekNames: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      dates: [],
      currentYear: 0,
      currentMonth: 0,
      year: 0,
      month: 0,
      currentDate: new Date().getDate(),
      prevDate: [],
      previewDate: []
    }
  },
  computed: {

    monthToString: function() {
      return this.months[this.month - 1];
    },
    isCurrentDate: function() {
      let status = false;
      if (this.currentYear === 0 && this.currentMonth === 0) {
        status = true;
      } else {
        status =
            this.currentYear === new Date().getFullYear() &&
            this.currentMonth === new Date().getMonth() + 1;
      }
      return status;
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    init(param) {
      if (param) {
        this.year = param[0];
        this.month = param[1];
        this.calendarDate();
      } else {
        const date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.calendarDate();
      }
    },
    calendarDate() {
      const [
        monthFirstDay,
        monthLastDate,
        prevMonthLastDate
      ] = this.getFirstDayLastDate(this.year, this.month);
      this.dates = this.getDaysOfMonth(
          monthFirstDay,
          monthLastDate,
          prevMonthLastDate
      );
    },
    getFirstDayLastDate(year, month) {
      const firstDay = new Date(year, month - 1, 1).getDay();
      const lastDate = new Date(year, month, 0).getDate();
      let lastMonth = month - 1;
      if (month === 1) {
        lastMonth = 12;
        year -= 1;
      }
      const prevLastDate = new Date(year, lastMonth, 0).getDate();
      return [firstDay, lastDate, prevLastDate];
    },
    getDaysOfMonth(monthFirstDay, monthLastDate, prevMonthLastDate) {
      let day = 1;
      let prevDay = prevMonthLastDate - monthFirstDay + 1;
      let dates = [];
      let dateList = [];
      let daysOfWeek = [];
      while (day <= monthLastDate) {
        if (day === 1) {
          this.getPrevDates(monthFirstDay, daysOfWeek, prevDay, dateList);
          this.padDates(daysOfWeek, dateList, false);
        }
        if (daysOfWeek.length === 7) {
          dates.push(daysOfWeek);
          day = daysOfWeek[daysOfWeek.length - 1];
          daysOfWeek = [];
        } else if (daysOfWeek.length < 7 && daysOfWeek.indexOf(monthLastDate) > -1) {
          this.padDates(daysOfWeek, dateList, true);
          dates.push(daysOfWeek);
          break;
        }
        day++;
        if (daysOfWeek.length <= 7) {
          const month = `${this.year}-${(this.month < 10) ? `0${this.month}` : this.month}`;
          dateList.push({
            date: `${month}-${(day < 10) ? `0${day}` : day}`,
            day: day
          })
          daysOfWeek.push(day);
        }
      }
      const filterDateList = [];
      const size = 7;
      for (let i = 0; i < dateList.length -1; i += size) {
        filterDateList.push(dateList.slice(i, i + size));
      }

      return filterDateList;
    },
    getPrevDates(monthFirstDay, daysOfWeek, prevDay, dateList) {
      const prevMonth = moment(`${this.year}${this.month}`, 'YYYYMM').subtract(1, "month").format('YYYY-MM');
      for (let j = 0; j < monthFirstDay; j++) {
        daysOfWeek.push(prevDay);
        this.prevDate.push(prevDay);
        dateList.push({
          date: `${prevMonth}-${prevDay}`,
          day: prevDay
        })
        prevDay += 1;
      }
    },
    padDates(daysOfWeek, dateList, isNextMonth) {
      const nextMonth = moment(`${this.year}${this.month}`, 'YYYYMM').add(1, "month").format('YYYY-MM');
      const len = daysOfWeek.length;
      const leftDays = 7 - len;
      if (len >= 0 && len < 7) {
        for (let i = 1; i <= leftDays; i++) {
          daysOfWeek.push(i);
          const month = (isNextMonth) ? `${nextMonth}` : `${this.year}-${(this.month < 10) ? `0${this.month}` : this.month}`;
          dateList.push({
            date: `${(month< 10) ? `0${month}` : month}-${(i < 10) ? `0${i}` : i}`,
            day: i
          })
          if (this.previewDate.length < leftDays) this.previewDate.push(i);
        }
      }
    },
    controlMonth(p) {
      if (p === "prev") {
        this.currentMonth = this.month - 1;
        this.currentYear = this.year;
        if (this.month === 1) {
          this.currentMonth = 12;
          this.currentYear = this.year -= 1;
        }
      } else {
        this.currentMonth = this.month + 1;
        this.currentYear = this.year;
        if (this.month === 12) {
          this.currentMonth = 1;
          this.currentYear = this.year += 1;
        }
      }
      const param = [this.currentYear, this.currentMonth];
      this.init(param);
    },
    controlYear(p) {
      if (p === "prev") {
        this.currentYear = this.year - 1;
      } else {
        this.currentYear = this.year + 1;
      }
      const param = [this.currentYear, this.month];
      this.init(param);
    },
    skipBy(p) {
      this.currentYear = new Date().getFullYear();
      if (p === "today") {
        this.currentMonth = new Date().getMonth() + 1;
      } else {
        this.currentMonth = p + 1;
      }
      const param = [this.currentYear, this.currentMonth];
      this.init(param);
    },
    getMatchedTodos(day) {
      return this.$store.state.todos.filter(todo => {
        const todoDate = new Date(todo.createdAt);
        const isDateMatched = todoDate.getDate() === day;
        const isMonthMatched = todoDate.getMonth() === this.month - 1;
        const isYearMathced = todoDate.getFullYear() === this.year;
        return isDateMatched && isMonthMatched && isYearMathced;
      });
    },
    isPrevDates(day, idx) {
      return (
          (this.prevDate.indexOf(day) > -1 && idx < 1) ||
          (this.previewDate.indexOf(day) > -1 && idx > 1)
      );
    },
    getScheduleOfDay(date) {
      return (this.calendar[date]) ? this.calendar[date] : null;
    },
    getHighRankOfDay(date) {
      return (this.dailyRanks[date]) ? this.dailyRanks[date].high : [];
    },
    getLowRankOfDay(date) {
      return (this.dailyRanks[date]) ? this.dailyRanks[date].low : [];
    },
  }
}
</script>

<style type="text/css">
.rounded {
  -moz-border-radius:20px 20px 20px 20px;
  border-radius:20px 20px 20px 20px;
  border:solid 1px #ffffff;
  background-color:#2b6bd1;
  padding:10px;
  color:#ffffff;
}

@media (min-width: 600px) {
  .col-lg5-custom {
    max-width: 20% !important;
    flex: 20% !important;
  }
}
</style>
